import { useParams } from 'react-router-dom';
import ArticleDetail from '../components/ArticleDetail.jsx';

export default function InsightDetailPage() {
  const { id } = useParams();
  return <ArticleDetail key={id} id={id} kind="insight" />;
}
